import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

const CHANNEL_IMAGE_REMOVE_BUTTON_SIZE = grid(3);
export const SELECTED_CHANNEL_IMAGE_SIZE = grid(10);
export const Styles = StyleSheet.create({
  horizontalUserList: {},
  horizontalUserListContentContainer: {
    padding: 5, // padding="small" on MBView
  },
  horizontalUserListRowImage: {
    width: 56,
    height: 56,
    borderRadius: 56 / 2,
    borderWidth: 4,
    borderColor: 'white',
    overflow: 'hidden',
  },
  horizontalUserListRowText: {
    maxWidth: 56,
  },
  horizontalUserListRowRemoveButton: {
    padding: 0,
    width: 18,
    height: 18,
    borderRadius: 18 / 2,
    backgroundColor: 'white',
  },
  horizontalUserListRowRemoveButtonPosition: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  selectChannelImageWrapper: {
    width: grid(9),
    height: grid(9),
    borderRadius: grid(9) / 2,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: Colors.v2.green,
  },
  selectedChannelImageWrapper: {
    width: SELECTED_CHANNEL_IMAGE_SIZE,
    height: SELECTED_CHANNEL_IMAGE_SIZE,
    borderRadius: SELECTED_CHANNEL_IMAGE_SIZE / 2,
    overflow: 'hidden',
    position: 'relative',
  },
  detailsUserList: {
    flexWrap: 'wrap',
  },
  channelImageRemoveButton: {
    padding: 0,
    width: CHANNEL_IMAGE_REMOVE_BUTTON_SIZE,
    height: CHANNEL_IMAGE_REMOVE_BUTTON_SIZE,
    borderRadius: CHANNEL_IMAGE_REMOVE_BUTTON_SIZE / 2,
    backgroundColor: 'white',
  },
  channelImageRemoveButtonPosition: {
    position: 'absolute',
    top: -grid(1), // balance out padding
    right: -grid(1), // balance out padding
    zIndex: 1,
    padding: grid(1), // for extra large click area
  },
  channelImageRemoveButtonOutline: {
    padding: 1,
    backgroundColor: 'white',
    borderRadius: (CHANNEL_IMAGE_REMOVE_BUTTON_SIZE + 2) / 2, // +2 due to padding adding a total of 2px to width/height
  },
  channelImageSelectorWrapper: {
    height: grid(20),
    backgroundColor: Colors.v2.gray05,
  },
  formColor: {
    backgroundColor: Colors.v2.white,
  },
  fillColor: {
    backgroundColor: Colors.v2.gray05,
  },
  imageSelectorPadding: {
    paddingHorizontal: '12.5%',
  },
});
